import {
    SubmittalStatusEnum,
    SubmittalSubStatusEnum
} from 'src/app/accountmanagers/submittals/model/enums/submittal-status.enum';

export interface SubmittalStatus {
    id: number;
    name: string;
    submittalTypeId: SubmittalTypes;
    subStatuses?: SubmittalSubStatus[];
    selected?: boolean | null;
    indeterminate?: boolean | null;
    current?: boolean | null;
}

export interface SubmittalStatusWithLegacyTranslationDto extends SubmittalStatus {
    newPermSubmittalStatusId: SubmittalStatusEnum | null;
    newPermSubmittalSubStatusId: SubmittalSubStatusEnum | null;
}

export enum SubmittalTypes {
    Regular = 1,
    PerDiem = 2,
    Staff = 3
}

export interface SubmittalSubStatus {
    id: number;
    name: string;
    selected?: boolean | null;
}
